<template>
  <router-view />
</template>

<script>
export default {
  name: 'Slates'
}
</script>
